import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Msq from "@MasterBluePrint/Components/Msq";
import { FormattedCommaSeparatedValue } from "@MasterBluePrint/Services/FormattedValueService";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";

import * as React from "react";
import { css } from "styled-components";

const enum fields {
    showMinQty = "showMinQty",
    minQtyLabel = "minQtyLabel",
    showMultQty = "showMultQty",
    mulQtyLabel = "mulQtyLabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showMinQty]: boolean;
        [fields.minQtyLabel]: string;
        [fields.showMultQty]: boolean;
        [fields.mulQtyLabel]: string;
    };
}
type Props = OwnProps & HasProduct;

export interface ProductDetailsMinMultiStyle {
    minMultiQtyContainer?: InjectableCss;
    minMultiWrapper?: InjectableCss;
    minQtyLabel?: InjectableCss;
    minQtyValue?: InjectableCss;
    maxQtyLabel?: InjectableCss;
    maxQtyValue?: InjectableCss;
}

export const minMulQtyStyles: ProductDetailsMinMultiStyle = {
    minMultiQtyContainer: {
        css: css`
            font-weight: 600;
            font-size: .9rem !important;
            font-family: 'Lato', sans-serif;
            font-style: italic;
            div {
                display: inline-block;
                margin-top: 1rem;
                position: relative;
            }
        `,
    },
    minMultiWrapper: {
        css: css`            
            font-size: .95rem !important;
            word-break: normal;
            margin-top: 0;
            margin-bottom: .5rem;
            position: relative;
            display: block;
            color: #333F48;
            font-family: 'Lato', sans-serif;
            letter-spacing:.01rem;
        `,
    },
    minQtyLabel: {
        css: css`
            margin-right:.4rem;
            font-weight: 700;
        `,
    },
    minQtyValue: {
        css: css`
            font-weight:400;
        `,
    },
    maxQtyLabel: {
        css: css`
            margin-right:.4rem;
            font-weight: 700;
        `,
    },
    maxQtyValue: {
        css: css`
            font-weight:400;
        `,
    },
};

const styles = minMulQtyStyles;

const ProductDetailsMinMulti: React.FC<Props> = ({ fields, product }) => {
    if (!product) {
        return null;
    }


    if (product) {
        return (
            <StyledWrapper>
                {fields.showMinQty && product.minimumOrderQty > 0 ? (
                    <StyledWrapper {...styles.minMultiWrapper} className="min-multi-detail">
                        <Typography {...styles.minQtyLabel}>
                            {fields.minQtyLabel || translate("Minimum order quantity: ")}
                        </Typography>
                        <Typography {...styles.minQtyValue}>
                            {FormattedCommaSeparatedValue(product.minimumOrderQty)}
                        </Typography>
                    </StyledWrapper>
                ) : ''}
                {fields.showMultQty && product.detail?.multipleSaleQty && product.detail?.multipleSaleQty > 1 ? (
                    <StyledWrapper {...styles.minMultiWrapper} className="min-multi-detail">
                        <Typography {...styles.minQtyLabel}>
                            {fields.mulQtyLabel || translate("Order in multiples of: ")}
                        </Typography>
                        <Typography {...styles.minQtyValue}>
                            {FormattedCommaSeparatedValue(product.detail?.multipleSaleQty)}
                        </Typography>
                    </StyledWrapper>
                ) : ''}
            </StyledWrapper>
        );
    }

    return <></>;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsMinMulti),
    definition: {
        displayName: "Min-Multi Qty",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.showMinQty,
                displayName: "Show Minimum Order Quantity?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            { 
                name: fields.minQtyLabel,
                editorTemplate: "TextField",
                defaultValue: "Minimum order quantity: ",
                fieldType: "General",
            },
            {
                name: fields.showMultQty,
                displayName: "Show Multiple Sale Quantity?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            {
                name: fields.mulQtyLabel,
                editorTemplate: "TextField",
                defaultValue: "Order in multiples of: ",
                fieldType: "General",
            },
        ]
    },
};
export default widgetModule;